export const tr = {
    '0-17': '18 yaş altı',
    '18-24': '18-24',
    '25-34': '25-34',
    '35-44': '35-44',
    '45-54': '45-54',
    '55-': '55 yaş üstü',
    age: 'Yaş',
    'all-ages': 'Herhangi',
    'all-genders': 'Hepsi',
    female: 'Kadın',
    male: 'Erkek'
};
